module.exports = __webpack_public_path__ + "img/27.4ae7aec4.jpg";